module.exports = __webpack_public_path__ + "static/img/4.ccaaf9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/4.png
// module id = +yHZ
// module chunks = 0